function Info() {
  return (
    <>
      <p>
        Code Unlimited is a platform for exploring new technologies, building
        innovative solutions, and continuously sharpening my craft. I believe
        the best way to learn — and to deliver real value — is through doing:
        building, testing, iterating.
      </p>
      <p>
        With a background in both hardware and software, and over two decades
        of experience as a consultant, I bring a deep understanding of how
        systems work together. This site showcases some of the projects and
        tools I develop to stay ahead in a rapidly evolving tech landscape —
        and to push the boundaries of what’s possible with clean, focused code.
      </p>
      <p>
        Over the years, I've had the opportunity to collaborate with a wide range
        of companies — from fast-moving startups to large, established enterprises.
        My clients have included organizations such as SJ (Swedish Railways),
        Marginalen Bank, SEB, Klarna, BookBeat, ASSA Abloy, UR (Swedish Educational
        Broadcasting), Kindred / Unibet, ATG, and many others across finance, media,
        tech, and public sectors.
      </p>
      <p>
        In addition to development, I'm also active in the tech community — writing
        blog posts, giving presentations, and organizing meetups to share knowledge
        and connect with others.
      </p>
      <p>
        My current focus is on Android development, where I specialize in building
        clean, high-performance mobile applications using modern architecture and
        design principles.
      </p>
      <p>
        I also work with React, particularly for building responsive, user-friendly
        web interfaces. While Android is my primary platform, staying hands-on with
        React helps me stay versatile and sharp across both mobile and web technologies.
      </p>
      <p>
        Over time, technologies evolve, and so do my interests. I regularly build
        and release apps and tools to experiment, learn, and solve real-world
        problems. Some of these include:<br />
        <ul>
          <li><a href="https://play.google.com/store/apps/details?id=se.codeunlimited.discgolf.lite"  rel="noopener noreferrer" target="_blank">Discgolf App</a>: advanced scorekeeper and toolset for disc golf players</li>
          <li><a href="https://play.google.com/store/apps/details?id=se.codeunlimited.bloodymaryguide"  rel="noopener noreferrer" target="_blank">Best Bloody Mary</a>: A niche platform for reviewing and discovering top Bloody Mary cocktails</li>
          <li>Various Open Source Projects: Available on <a href="https://github.com/ptornhult"  rel="noopener noreferrer" target="_blank">GitHub</a></li>
        </ul>
      </p>
      <p>     
        These projects help me stay sharp, explore new ideas, and give back to the developer community.
      </p>
      <p className="signed">/Peter</p>
    </>
  )
}

export default Info
